import { render, staticRenderFns } from "./LingueFlags.vue?vue&type=template&id=6675bb42&scoped=true"
import script from "./LingueFlags.vue?vue&type=script&lang=js"
export * from "./LingueFlags.vue?vue&type=script&lang=js"
import style0 from "./LingueFlags.vue?vue&type=style&index=0&id=6675bb42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6675bb42",
  null
  
)

export default component.exports